// Promote legacy SKU → document links into first-class COA records.
// This is deliberately repeatable: running it again only repairs/extends records.
function reconcileCoaDocumentLinks(state, makeId, timestamp) {
  state.coas = Array.isArray(state.coas) ? state.coas : []
  var documents = Array.isArray(state.documents) ? state.documents : []
  var docById = {}
  documents.forEach(function(doc) { docById[doc.id] = doc })

  var linksByDocument = {}
  ;(state.peptides || []).forEach(function(peptide) {
    ;(peptide.skus || []).forEach(function(sku) {
      var ids = Array.isArray(sku.coaDocIds) ? sku.coaDocIds.slice() : []
      if (sku.coaDocId && ids.indexOf(sku.coaDocId) < 0) ids.push(sku.coaDocId)
      ids.filter(Boolean).forEach(function(documentId) {
        if (!linksByDocument[documentId]) linksByDocument[documentId] = []
        if (!linksByDocument[documentId].some(function(link) { return link.skuId === sku.id })) {
          linksByDocument[documentId].push({ skuId: sku.id, vendor: sku.vendor || '' })
        }
      })
    })
  })

  var vendorByName = {}
  ;(state.vendors || []).forEach(function(vendor) {
    if (vendor.name) vendorByName[vendor.name.trim().toLowerCase()] = vendor.id
  })

  var result = { created: 0, updated: 0, linkedDocuments: 0, missingDocuments: 0, totalLinks: 0 }
  Object.keys(linksByDocument).forEach(function(documentId) {
    var links = linksByDocument[documentId]
    result.totalLinks += links.length
    var doc = docById[documentId]
    if (!doc) { result.missingDocuments++; return }
    result.linkedDocuments++
    var coa = state.coas.find(function(item) { return item.documentId === documentId })
    var lotIds = links.map(function(link) { return link.skuId }).filter(Boolean)
    var vendorIds = links.map(function(link) { return vendorByName[link.vendor.trim().toLowerCase()] }).filter(Boolean)
      .filter(function(id, index, all) { return all.indexOf(id) === index })
    if (coa) {
      var before = (coa.lotIds || []).length
      coa.lotIds = (coa.lotIds || []).concat(lotIds).filter(function(id, index, all) { return all.indexOf(id) === index })
      if (!coa.vendorId && vendorIds.length === 1) coa.vendorId = vendorIds[0]
      if (!coa.source) coa.source = 'sku-document-link'
      if (!coa.migrationStatus) coa.migrationStatus = 'needs-review'
      coa.sourceLinkCount = links.length
      if (coa.lotIds.length !== before) result.updated++
      return
    }
    var rawName = doc.originalName || doc.name || 'COA'
    state.coas.push({
      id: makeId(), vendorId: vendorIds.length === 1 ? vendorIds[0] : '', lotIds: lotIds,
      orderId: '', documentId: documentId, testLab: '', reportNo: rawName.replace(/\.[^.]+$/, ''),
      testDate: '', results: [], notes: 'Created from existing SKU document links. Review and add certificate details.',
      source: 'sku-document-link', migrationStatus: 'needs-review', sourceLinkCount: links.length,
      createdAt: doc.addedAt || timestamp()
    })
    result.created++
  })
  return result
}

export { reconcileCoaDocumentLinks }
